var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55959 20.7749C-1.18658 16.0287 -1.18648 8.30592 3.55959 3.55968C8.30586 -1.18656 16.0286 -1.18656 20.7747 3.55968C24.8013 7.58622 25.4111 13.5747 22.6059 18.2511C22.6059 18.2511 22.4044 18.5891 22.6765 18.8611C24.2291 20.4136 28.8871 25.0717 28.8871 25.0717C30.1233 26.3077 30.4176 28.0362 29.3213 29.1326L29.1326 29.3211C28.0364 30.4176 26.3078 30.1234 25.0717 28.8872C25.0717 28.8872 20.4235 24.239 18.8741 22.6897C18.589 22.4045 18.251 22.606 18.251 22.606C13.5747 25.4112 7.58616 24.8014 3.55959 20.7749ZM18.5274 18.5275C22.0344 15.0205 22.0343 9.31429 18.5273 5.80731C15.0203 2.30042 9.31405 2.30032 5.80714 5.80731C2.30014 9.31419 2.30014 15.0205 5.80714 18.5275C9.31415 22.0343 15.0203 22.0343 18.5274 18.5275Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.b8a81293.svg";
export { ForwardRef as ReactComponent };